import { render, staticRenderFns } from "./TopMandates.vue?vue&type=template&id=1b1bab05&"
import script from "./TopMandates.vue?vue&type=script&lang=js&"
export * from "./TopMandates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports